import { Type } from "class-transformer";
import { IsArray, ValidateNested } from "class-validator";
import { IsArrayOfInstancesOf } from "../../class-validator/class-validator-constraints";
import { DeviceDto } from "./device.dto";
import { FamilyDto } from "./family/family.dto";

export class MonitoringProductCategoryDto {
  @IsArray()
  @IsArrayOfInstancesOf(FamilyDto)
  @ValidateNested({ each: true })
  @Type(() => FamilyDto)
  families!: FamilyDto[];

  @IsArray()
  @IsArrayOfInstancesOf(DeviceDto)
  @ValidateNested({ each: true })
  @Type(() => DeviceDto)
  devices!: DeviceDto[];
}
